export default __webpack_public_path__ + "static/media/010.b2acc633.jpg";